import { createSlice } from '@reduxjs/toolkit';
import { resetOnLogout } from '~/reducers/common-actions';

export const appGlobalsSlice = createSlice({
    name: 'appGlobals',
    initialState: {
        isAppInitialized: false
    },
    reducers: {
        setAppInitialized: (state, action) => {
            state.isAppInitialized = action.payload;
            return state;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(resetOnLogout, () => {
            return {
                isAppInitialized: false
            };
        });
    }
});

export const { setAppInitialized } = appGlobalsSlice.actions;
export const selectAppInitialized = (state) =>
    state.appGlobals.isAppInitialized;

export default appGlobalsSlice.reducer;
